<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 新增分组
      </el-button>
      <div class="former">
        <el-input
          v-model="former['Name:like']"
          placeholder="名称"
          @keydown.enter.native="onSubmitQuery">
        </el-input>&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column type="index" :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * (pager.page)).toString().length * 12)" />
      <el-table-column prop="Name" label="分组名称" />
      <el-table-column prop="Devices_name" label="工控机" />
      <el-table-column prop="Comment" label="说明" />
      <el-table-column width="120" label="操作">
        <template slot-scope="scope">
          <el-button type="primary" @click.stop="onEditItem(scope.row)" title="编辑">
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button type="danger" @click.stop="onDeleteItem(scope.row)" title="删除">
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size">
      </el-pagination>
    </div>

    <item-form v-model="item"
      :visible.sync="itemVisible"
      @form:saved="getItemList" />
  </el-card>
</template>

<script>
import ItemForm from './index--form.vue';

export default {
  components: {
    ItemForm,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        'Name:like': '',
      },
      item: this.getEmptyItem(),
      itemVisible: false,
    };
  },
  mounted() {},
  created() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios.get('ipcdgroup', {
        params: {
          where: this.former,
          with: ['IpcDevices'],
          ...this.pager,
        },
      }).then((response) => {
        // this.itemList = response.data.data;
        const list = response.data.data;
        list.map((ele) => {
          const obj = ele;
          obj.Devices_name = _.isArray(obj.DciDevices)
            ? obj.DciDevices.map(e => e.Name).join(', ')
            : '';
          return obj;
        });
        this.itemList = list;
        this.pager = _.pick(response.data, 'size', 'page', 'total');
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      }).finally(() => {
        this.loading = false;
      });
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.itemVisible = true;
    },
    getEmptyItem() {
      return {
        Comment: '',
        Name: '',
      };
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onEditItem(row) {
      this.item = {
        ID: row.ID,
        Name: row.Name,
        Comment: row.Comment,
      };
      this.itemVisible = true;
    },
    onDeleteItem(row) {
      this.$confirm('确定要删除此分组吗？', '提示').then(
        () => this.$axios.delete(`ipcdgroup/${row.ID}`)
      ).then(() => {
        this.getItemList();
        this.$message.success('成功删除分组');
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },
  },
};
</script>
